import { getAvailableModels } from './openRouterService';

export async function getImageCapableModels(apiKey) {
  const models = await getAvailableModels(false, apiKey || null);
  return (Array.isArray(models) ? models : []).map((m) => ({
    value: m.id,
    label: `${m.name}${m.isFree ? ' (FREE)' : ' (PAID)'}${m.isAvailable === false ? ' [Unavailable]' : ''}`,
    disabled: m.isAvailable === false,
  }));
}

export function splitPrompts(raw) {
  if (!raw || typeof raw !== 'string') return [];
  return raw
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
}

